import { RootState } from "../store";

export const selectQuestionnaires = (state: RootState) => state.questionnaires.questionnaires;
export const selectQuestionnairesLoading = (state: RootState) => state.questionnaires.loading;
export const selectDrafts = (state: RootState) => state.questionnaires.drafts;
export const selectAllowAnswers = (state: RootState) => state.questionnaires.allow_answers; 